


































































































































































import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import { TYPES as BOOKING_TYPES, BOOKING_PURPOSES } from '@/constants/booking';
import QShareCode from '@/components/QShareCode.vue';
import { reportOutcome } from '@/utils/questionnaire';
import { mapState } from 'vuex';
import BookingReadBookingCandidateFormFields from '../Booking/Read/BookingReadBookingCandidateFormFields.vue';

@Component({
  components: {
    QShareCode,
    BookingReadBookingCandidateFormFields,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('UserPreference', {
      userPreference: 'single',
    }),
    ...mapState('Booking', {
      booking: 'booking',
    }),
  },
})
export default class BusinessDashboardBookingDrawer extends Vue {
  @ModelSync('show', 'change') readonly showCandidateListDrawer!: boolean;
  @Prop() readonly outcomes!: reportOutcome[];

  loading!: boolean;
  userPreference!: Model;
  booking!: Booking;

  bookingTypes = BOOKING_TYPES;
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;
  bookingPurposes = BOOKING_PURPOSES;

  search = '';
  filterByOutcomes = [
    'high_risk',
    'moderate',
    'low_risk',
    'incomplete',
    'complete',
  ];
  selectedBookingCandidate: Model | null = null;
  showUpdateDialog = false;

  reload = 0;

  get isHealthCheck() {
    return (
      this.booking.purpose ===
      this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    );
  }

  get candidateTableHeaders() {
    return [
      {
        text: 'Candidate',
        value: 'candidate',
      },
      ...(this.showStatus
        ? [
            {
              text: 'Outcome',
              value: 'outcome',
            },
          ]
        : []),
      ...(this.isHealthCheck
        ? []
        : [
            {
              text: 'Recommendation',
              value: 'recommendation',
            },
          ]),
      {
        text: 'Action',
        value: 'action',
      },
    ];
  }

  /**
   * Show the individual status if one of following conditions is true:
   * - the booking is general health check
   * - the userPreference does not exist (It means showing the status by default)
   * - ghc_booking_candidate_status_enabled in userPreference is true
   */
  get showStatus() {
    return (
      !this.isHealthCheck ||
      !this.userPreference ||
      this.userPreference?.booking_settings
        ?.ghc_booking_candidate_status_enabled
    );
  }

  get statuses() {
    return this.outcomes.map((outcome) => ({
      text: outcome.label,
      color: outcome.color,
      dark: outcome.dark,
      value: outcome.value,
    }));
  }

  get bookingCandidates() {
    if (!this.booking.booking_candidates) {
      return [];
    }
    return this.booking.booking_candidates
      .map((bookingCandidate) => ({
        ...bookingCandidate,
        outcome: this.getOutcome(bookingCandidate),
      }))
      .filter(
        (bookingCandidate) =>
          bookingCandidate.outcome &&
          bookingCandidate.outcome.value &&
          this.filterByOutcomes.includes(bookingCandidate.outcome.value)
      );
  }

  filterCandidate(_, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          'first_name',
          'last_name',
          'date_of_birth',
          'mobile',
          'email',
        ].includes(k) &&
        item[k]
          .toString()
          .toLowerCase()
          .includes(search)
      );
    });
  }

  isCompleted(item) {
    return item.status === this.bookingCandidateStatuses.STATUS_COMPLETED.key;
  }

  getOutcome(item) {
    return this.outcomes.find((outcome) =>
      outcome.booking_candidate_oids.includes(item.object_id)
    );
  }

  openUpdateDialog(item) {
    this.showUpdateDialog = true;
    this.selectedBookingCandidate = item;
    this.reload++;
  }

  canSendNotification(item) {
    return [
      this.bookingCandidateStatuses.STATUS_CREATED.key,
      this.bookingCandidateStatuses.STATUS_AWAIT_CANDIDATE_RESPONSE.key,
      this.bookingCandidateStatuses.STATUS_CANDIDATE_INPUTTING.key,
      this.bookingCandidateStatuses.STATUS_AWAIT_CONFIRMED_POLICY.key,
      this.bookingCandidateStatuses.STATUS_AWAIT_START.key,
      this.bookingCandidateStatuses.STATUS_AWAIT_RESULT.key,
    ].includes(item.status);
  }
}
